var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],class:[
    {open: _vm.isOpen},
    {dropdown: _vm.direction === 'down'},
    {dropup: _vm.direction === 'up'}
  ],on:{"click":_vm.toggleDropDown}},[_c('md-field',[_vm._t("input")],2),(_vm.isOpen)?_c('div',{staticClass:"drop-down-area"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }